// @flow

import ActionTypes from './action-types';
import type { ProjectWeeklyProgressAction, ProjectWeeklyProgress } from './sagas';

export type ProjectWeeklyCostProgressState = {
  chartData: ProjectWeeklyProgress[],
  projectStart: string | null,
  costEnable: boolean | null,
  loading: boolean | null,
};

const initialState: ProjectWeeklyCostProgressState = {
  loading: null, chartData: [], projectStart: null, costEnable: null,
};

export default function (state: ProjectWeeklyCostProgressState = initialState, action: ProjectWeeklyProgressAction): ProjectWeeklyCostProgressState {
  switch (action.type) {
    case ActionTypes.GET_PROJECT_WEEKLY_COST_PROGRESS_SUCCESS:
      return {
        ...state,
        chartData: action.data.weekly_progress,
        projectStart: action.data.project_start_date,
        costEnable: action.data.cost_enabled,
        loading: false,
      };
    case ActionTypes.GET_PROJECT_WEEKLY_COST_PROGRESS_FAIL:
      return {
        ...state,
        chartData: [],
        projectStart: null,
        costEnable: null,
        loading: false,
      };
    default:
      return state;
  }
}
